import { privateApi } from "./axios";

export const getPayrollSettings = async () => {
    try {
        const response = await privateApi.get("api/sc/payroll/settings");
        return response;
    } catch (error) {
        throw error;
    }
}

export const getPayrollSettingsByCustomer = async (idCustomer: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${idCustomer}/settings`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updatePayrollSettings = async (data: any) => {
    try {
        const response = await privateApi.patch(`api/sc/payroll/settings`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updatePayrollSettingsByCustomer = async (idCustomer: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/sc/customerfile/${idCustomer}/settings`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const postPayrollSimulator = async (data: any) => {
    try {
        const response = await privateApi.post(`api/sc/payroll-simulator`, data, {
            responseType: "blob",
        });
        return response;
    } catch (error) {
        throw error;
    }
}